export function BoundaryFallbackUI() {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 text-center">
      <h1 className="text-2xl font-semibold mb-4">An unexpected error occurred.</h1>
      <p className="text-gray-600 mb-8">
        Please close and reopen this page, or contact support if the issue persists.
      </p>
      <button
        className="px-6 py-3 bg-black text-white rounded-full font-medium"
        onClick={() => window.location.reload()}
      >
        Try again
      </button>
    </div>
  );
}
